import(/* webpackMode: "eager" */ "/app/node_modules/@fontsource-variable/fraunces/opsz.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/presentation/presentation.css");
;
import(/* webpackMode: "eager", webpackExports: ["PresentationRam"] */ "/app/src/sections/presentation/komponenter/PresentationRam.tsx");
